import { IState } from '../types/state';

const resetEvents = (state: IState) => {
  state.specialEvents.data = [];
  state.specialEvents.scrollToSelectedEvent = '';
};

export default resetEvents;
